import { ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function CartButton({ compact = false }) {
  const { count, setOpen } = useCart();
  return (
    <button
      data-testid="cart-toggle"
      onClick={() => setOpen(true)}
      aria-label="Open cart"
      title={`Cart (${count})`}
      className={`relative flex items-center justify-center rounded-full border border-[var(--theme-border)] hover:border-[var(--theme-accent-primary)]/60 bg-transparent hover:bg-[var(--theme-accent-primary)]/10 text-[var(--accent)] transition-colors ${
        compact ? "w-9 h-9" : "w-10 h-10"
      }`}
    >
      <ShoppingCart size={17} />
      {count > 0 && (
        <span
          data-testid="cart-badge"
          className="absolute -top-1.5 -right-1.5 bg-[var(--accent)] text-black font-mono text-[10px] font-bold px-1.5 py-[1px] tracking-tight min-w-[18px] text-center rounded-full shadow-[0_0_12px_rgba(var(--theme-accent-primary-rgb),0.5)]"
        >
          {count}
        </span>
      )}
    </button>
  );
}
